<template>
  <div class="basket-list-desktop">
    <unavailable-panel
        v-if="unavailableItemsLength"
        class="basket-list-desktop__unavailable-panel"
        @onDeleteAll="handlerClickDeleteUnavailable"
    />
    <product-item
      v-for="(item, index) in items"
      :key="item.id"
      :product-id="item.product.id"
      :basket-item-id="item.id"
      :product-name="item.product.name"
      :product-code="item.product.code"
      :amount="item.amount"
      :link="item.product.link"
      :category-id="getCategoryItem(item.product)"
      :quantity-in-basket="item.quantity"
      :quantity-available="item.product.quantity"
      :picture="item.product.picture"
      :is-moved="item.isMoved"
      :is-deleted="item.isDeleted"
      :is-available="item.product.isAvailable && item.product.quantity > 0"
      :is-pre-order="item.product.isPreOrder"
      :is-buy-only-pre-paid="item.product.isBuyOnlyPrePaid"
      :is-promo-disabled="item.product.isPromoDisabled"
      :is-purchased="getIsPurchased(item.product.productUserStats)"
      :is-gift="item.isGift"
      :author-list="item.product.author"
      :is-loading="item.isLoading"
      :show-change-gift="showChangeGift"
      :is-last-unavailable="isLastUnavailableItem(index)"
      class="basket-list-desktop__item"
      @spliceItem="handlerSpliceItem"
      @restoreItem="handlerRestoreItem"
      @updateQuantityItem="handlerUpdateQuantityItem"
      @moveToWishList="handlerMoveToWishList"
      @removeItem="handlerRemoveItem"
      @openAuthModal="handlerClickAuth"
      @clickNotAvailable="handlerClickNotAvailable"
      @clickChangeGift="handlerClickChangeGift"
    />
    <loader-block v-if="isLoading" text="" class="basket-list-desktop__loader" />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import { LoaderBlock } from '@book24/ui-components';

import useBasketList from '@/compositions/useBasketList';

import ProductItem from '@/components/_desktop/ProductItem/index.vue';
import UnavailablePanel from '@/components/UnavailablePanel';

export default defineComponent({
  name: 'BasketList',
  components: {
    ProductItem,
    LoaderBlock,
    UnavailablePanel,
  },
  props: {
    items: { type: Array, default: () => ([]) },
    isLoading: { type: Boolean, default: false },
    showChangeGift: { type: Boolean, default: false },
    unavailableItemsLength: { type: Number, default: 0 },
  },
  setup(props) {
    const basketList = useBasketList(props);
    return { ...basketList };
  },
});
</script>

<style lang="less">
.basket-list-desktop {
  position: relative;

  &__unavailable-panel {
    margin: @size-x8 -@size-x4 0;
  }

  &__item {
    border-bottom: 1px solid @gray-super-light;
  }

  &__loader.b24-loader-block {
    z-index: 2;
    left: -@size-x4;
    width: calc(100% + @size-x8);
  }
}
</style>
